import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('TabsDropdownController', null, {
    withChildren: true,
});
